// Dnes: jedno volání GET /v1/today (docs/SPEC.md 2.3).
import type { TodayResponse } from '@wac-buddy/shared'
import { api } from './client'

export function getToday(): Promise<TodayResponse> {
  return api('/today')
}
